// 댓글 삭제 모달을 관리
import { create } from 'zustand';

interface CommentDeleteModalState {
    isOpen: boolean;
    targetType: 'comment' | null;
    targetId: string | null;
    hasReply: boolean;
    onConfirm: ((commentId: string) => void) | null;

    openModal: ({
        targetId,
        targetType,
        hasReply,
        onConfirm,
    }: {
        targetId: string;
        targetType: 'comment';
        hasReply: boolean;
        onConfirm: (commentId: string) => void;
    }) => void;
    closeModal: () => void;
}

export const useCommentDeleteModalStore = create<CommentDeleteModalState>(
    set => ({
        isOpen: false,
        targetType: null,
        targetId: null,
        hasReply: false,
        onConfirm: null,

        openModal: ({ targetId, targetType, hasReply, onConfirm }) => {
            set({
                isOpen: true,
                targetType,
                targetId,
                hasReply,
                onConfirm,
            });
        },
        closeModal: () => {
            set({
                isOpen: false,
                targetType: null,
                targetId: null,
                hasReply: false,
                onConfirm: null,
            });
        },
    })
);
